import { useState } from 'react';

export const useSupportFormValidation = () => {
  const [phoneError, setPhoneError] = useState<string>('');
  const [messageError, setMessageError] = useState<string>('');
  const [emailError, setEmailError] = useState<string>('');
  const [parkingRestrictionDetailError, setParkingRestrictionDetailError] = useState<string>('');
  const [accessRestrictionDetailError, setAccessRestrictionDetailError] = useState<string>('');
  const [accessToMetersAbove8ftDetailError, setAccessToMetersAbove8ftDetailError] = useState<string>('');
  const [vulnerabilitiesOnSiteDetailError, setVulnerabilitiesOnSiteDetailError] = useState<string>('');

  const validatePhoneInput = (phone: string) => {
    if (!phone.length) {
      setPhoneError('Required field');
    } else if (!/^(?:\W*\d){11}\W*$/.test(phone)) {
      setPhoneError('Invalid format');
    } else {
      setPhoneError('');
    }
  };

  const validateContactNumberInput = (phone: string) => {
    if (!phone.length) {
      setPhoneError('Required');
    } else if (!/^(?:\W*\d){11}\W*$/.test(phone)) {
      setPhoneError('Please provide a valid phone number without spaces');
    } else {
      setPhoneError('');
    }
  };

  const validateMessageInput = (msg: string) => {
    if (!msg.length) {
      setMessageError('Required field');
    } else if (msg.length < 10) {
      setMessageError('Please enter at least 10 characters in the message field');
    } else {
      setMessageError('');
    }
  };

  const validateInput = (msg: string) => {
    if (!msg.length) {
      setMessageError('Required');
    } else {
      setMessageError('');
    }
  };

  const validateParkingRestrictionDetail = (msg: string) => {
    if (!msg.length) {
      setParkingRestrictionDetailError('Required');
    } else {
      setParkingRestrictionDetailError('');
    }
  };

  const validateAccessRestrictionDetail = (msg: string) => {
    if (!msg.length) {
      setAccessRestrictionDetailError('Required');
    } else {
      setAccessRestrictionDetailError('');
    }
  };

  const validateAccessToMetersAbove8ftDetail = (msg: string) => {
    if (!msg.length) {
      setAccessToMetersAbove8ftDetailError('Required');
    } else {
      setAccessToMetersAbove8ftDetailError('');
    }
  };

  const validateVulnerabilitiesOnSiteDetail = (msg: string) => {
    if (!msg.length) {
      setVulnerabilitiesOnSiteDetailError('Required');
    } else {
      setVulnerabilitiesOnSiteDetailError('');
    }
  };

  const validateEmailInput = (msg: string) => {
    if (!msg.length) {
      setEmailError('Required');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(msg)) {
      setEmailError('Please provide a valid email address');
    } else {
      setEmailError('');
    }
  };

  const clearPhoneValidation = () => {
    setPhoneError('');
  };

  const clearAllValidation = () => {
    setPhoneError('');
    setMessageError('');
  };

  return {
    phoneError,
    messageError,
    emailError,
    parkingRestrictionDetailError,
    accessRestrictionDetailError,
    accessToMetersAbove8ftDetailError,
    vulnerabilitiesOnSiteDetailError,
    validatePhoneInput,
    validateContactNumberInput,
    validateMessageInput,
    validateInput,
    validateParkingRestrictionDetail,
    validateAccessRestrictionDetail,
    validateAccessToMetersAbove8ftDetail,
    validateVulnerabilitiesOnSiteDetail,
    validateEmailInput,
    clearPhoneValidation,
    clearAllValidation,
  };
};
